import { render, staticRenderFns } from "./Navigate.vue?vue&type=template&id=b120817a&lang=pug&"
import script from "./Navigate.vue?vue&type=script&lang=js&"
export * from "./Navigate.vue?vue&type=script&lang=js&"
import style0 from "./Navigate.vue?vue&type=style&index=0&id=b120817a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports